import { decodeHtml } from '@tencent/imutils/dist/esm/util_02';
import { request } from '@tencent/imutils/dist/esm/util_21_request';
import { getCookie } from '@tencent/imutils/dist/esm/util_03_cookie';
import { isMQQ } from '@tencent/imutils/dist/esm/util_04_ua';
import { promiseWrapper } from './common';

let userData = null;
let getUserInfoPromise = null;

export function getUserInfo() {
  if (userData) {
    return Promise.resolve(userData);
  }

  if (getUserInfoPromise) {
    return getUserInfoPromise;
  }

  getUserInfoPromise = request('/cgi-bin/getLoginUserInfo', {
    method: 'GET',
    needLogin: false,
  })
    .then(data => {
      const { retcode, result } = data;

      if (retcode !== 0 || !result) {
        return Promise.reject(data);
      }

      userData = result;
      return result;
    })
    .finally(() => (getUserInfoPromise = null));

  return getUserInfoPromise;
}

export function getUserAvatar() {
  return getUserInfo().then(result => decodeHtml(result.headimgurl));
}

export function getUserName() {
  return getUserInfo().then(result => result.nickname);
}

let userPhone = null;
let getUserPhonePromise = null;

export const getUserPhone = () => {
  if (userPhone) {
    return Promise.resolve(userPhone);
  }

  if (getUserPhonePromise) {
    return getUserPhonePromise;
  }

  let uidType = +getCookie('uid_type');
  if (+getCookie('uid_type') === 1002) {
    uidType = +getCookie('uid_origin_uid_type');
  }
  if (isMQQ()) {
    uidType = 0;
  }

  return request({
    url: '/cgi-proxy/order/ad_pay_simple/get_user_login_phone',
    needLogin: false,
    params: {
      uid_type: uidType,
    },
  })
    .then(({ result: data }) => {
      const { ret_code, login_phone } = data;

      if (ret_code !== 0 || !login_phone) {
        return Promise.reject(data);
      }

      userPhone = login_phone;
      return login_phone;
    })
    .finally(() => (getUserPhonePromise = null));
};

export function reqLoginWithCode(phoneNumber, codeNumber) {
  const phone = phoneNumber.toString();
  const code = codeNumber.toString();
  return promiseWrapper(
    request({
      url: '/cgi-bin/uidaccount/k12/phone/new_login',
      method: 'POST',
      needLogin: false,
      params: {
        phone,
        ext: JSON.stringify({
          action: 1,
          sms_code: code,
          uid: phone,
          phone,
          ts: Date.now(),
          uid_type: 1002,
          send_type: 2, // sendType = 1 短信；2 是语音 (兼容 语音和短信)
          platform: 5,
          app_id: 1001,
          password: '',
        }),
      },
    }).then(({ result: { code, is_bind } = {} }) => {
      if (code !== 0) {
        return Promise.reject({ code, is_bind });
      }
      return Promise.resolve();
    })
  );
}
